import english from '../translations/en.json';
import greek from '../translations/gr.json';
import spanish from '../translations/es.json';
import { normalizeLocale } from './locales';

const messages = {
  'en-US': english,
  el: { ...english, ...greek },
  es: { ...english, ...spanish },
};

export const getLocaleMessages = locale => messages[normalizeLocale(locale)];
